const sizeConfigs = {
    sidebar: {
      width: 200
    }
};
  
export default sizeConfigs;
  